<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light navbar-stick-dark" data-navbar="sticky">
      <header-component></header-component>
    </nav>
    <header
      class="header text-white h-fullscreen overflow-hidden"
      style="background-image: linear-gradient(-45deg, #667eea 0%, #764ba2 100%)"
    >
      <canvas class="constellation" data-radius="0"></canvas>
      <div class="container position-static">
        <div class="row align-items-center h-100">
          <div class="col-lg-7">
            <h1 class="display-4 fw-500">
              Built For
              <span
                class="fw-400 pl-2"
                data-typing="Startups, Entrepreneurs, Makers, Developers"
                data-type-speed="80"
              ></span>
            </h1>
            <p class="lead mt-5 mb-7 mb-md-9 w-80">
              at <strong>Amsa</strong> We build technology solutions for your business
            </p>
          </div>

          <div class="col-lg-5 d-none d-lg-block"></div>
        </div>

        <div class="d-none d-lg-block sample-blocks">
          <a href="/dhanvantari" target="_blank">
            <img
              class="shadow-6"
              :src="noip1"
              alt="..."
              data-aos="fade-up"
              data-aos-delay="0"
              data-aos-offset="0"
            />
          </a>

          <a href="http://www.kabirinstitute.in/" target="_blank">
            <img
              class="shadow-6"
              :src="kabir"
              alt="..."
              data-aos="fade-up"
              data-aos-delay="200"
              data-aos-offset="0"
            />
          </a>

          <a href="https://www.charudattaaphale.com/" target="_blank">
            <img
              class="shadow-6"
              :src="aphale"
              alt="..."
              data-aos="fade-up"
              data-aos-delay="400"
              data-aos-offset="0"
            />
          </a>

          <a href="http://piling.amsainfotech.com/" target="_blank">
            <img
              class="shadow-6"
              :src="piling"
              alt="..."
              data-aos="fade-up"
              data-aos-delay="600"
              data-aos-offset="0"
            />
          </a>

          <a href="/inventory" target="_blank">
            <img
              class="shadow-6"
              :src="inventory"
              alt="..."
              data-aos="fade-up"
              data-aos-delay="800"
              data-aos-offset="0"
            />
          </a>

          <a href="/dhanvantari" target="_blank">
            <img
              class="shadow-6"
              :src="dhanvantari6"
              alt="..."
              data-aos="fade-up"
              data-aos-delay="1000"
              data-aos-offset="0"
            />
          </a>

          <a href="http://piling.amsainfotech.com/" target="_blank">
            <img
              class="shadow-6"
              :src="piling1"
              alt="..."
              data-aos="fade-up"
              data-aos-delay="1200"
              data-aos-offset="0"
            />
          </a>

          <a href="http://www.kabirinstitute.in/" target="_blank">
            <img
              class="shadow-6"
              :src="kabir1"
              alt="..."
              data-aos="fade-up"
              data-aos-delay="1400"
              data-aos-offset="0"
            />
          </a>

          <a href="https://www.charudattaaphale.com/" target="_blank">
            <img
              class="shadow-6"
              :src="rajput2"
              alt="..."
              data-aos="fade-up"
              data-aos-delay="1700"
              data-aos-offset="0"
            />
          </a>
        </div>
      </div>
    </header>

    <section id="section-demo" class="section overflow-hidden bg-gray">
      <div class="container">
        <header class="section-header">
          <h2>Our Portfolio</h2>
          <hr />
          <p class="lead">
            We partner with innovative companies at every stage, help them accelerate their growth
            and achieve their unique goals. Have a look at some of our favorite projects to date.
          </p>
        </header>

        <div class="row gap-y">
          <!-- <div class="col-6 col-lg-4" data-aos="fade-up" data-aos-delay="0">
            <a
              class="card shadow-1 hover-shadow-7"
              href="https://www.charudattaaphale.com/"
              target="_blank"
            >
              <img class="card-img-top" :src="aphale2" alt="Demo" />
              <div class="card-body">
                <h6 class="mb-0">Kirtan Performer - Mr. Charudatta Aphale</h6>
              </div>
            </a>
          </div> -->

          <div class="col-6 col-lg-4" data-aos="fade-up" data-aos-delay="0">
            <a
              class="card shadow-1 hover-shadow-7"
              href="https://noipindia.com/home"
              target="_blank"
            >
              <img class="card-img-top" :src="noip" alt="Demo" />
              <div class="card-body">
                <h6 class="mb-0">National Org. Of Insurance Pensioners</h6>
              </div>
            </a>
          </div>

          <div class="col-6 col-lg-4" data-aos="fade-up" data-aos-delay="0">
            <a class="card shadow-1 hover-shadow-7" href="https://rajputele.com/" target="_blank">
              <img class="card-img-top" :src="rajput" alt="Demo" />
              <div class="card-body">
                <h6 class="mb-0">Rajput Electricals & Rajdoot Services</h6>
              </div>
            </a>
          </div>

          <div class="col-6 col-lg-4" data-aos="fade-up" data-aos-delay="150">
            <a class="card shadow-1 hover-shadow-7" href="/dhanvantari" target="_blank">
              <img class="card-img-top" :src="dhanvantari2" alt="Demo" />
              <div class="card-body">
                <h6 class="mb-0">Clinic Management</h6>
              </div>
            </a>
          </div>

          <div class="col-6 col-lg-4" data-aos="fade-up" data-aos-delay="150">
            <a
              class="card shadow-1 hover-shadow-7"
              href="http://www.kabirinstitute.in/"
              target="_blank"
            >
              <img class="card-img-top" :src="kabir2" alt="Demo" />
              <div class="card-body">
                <h6 class="mb-0">Kabir Institute</h6>
              </div>
            </a>
          </div>

          <div class="col-6 col-lg-4" data-aos="fade-up" data-aos-delay="0">
            <a class="card shadow-1 hover-shadow-7" href="/inventory" target="_blank">
              <img class="card-img-top" :src="inventory1" alt="Demo" />
              <div class="card-body">
                <h6 class="mb-0">Inventory Management</h6>
              </div>
            </a>
          </div>

          <div class="col-6 col-lg-4" data-aos="fade-up" data-aos-delay="300">
            <a
              class="card shadow-1 hover-shadow-7"
              href="http://piling.amsainfotech.com/"
              target="_blank"
            >
              <img class="card-img-top" :src="piling2" alt="Demo" />
              <div class="card-body">
                <h6 class="mb-0">Global Piling Community</h6>
              </div>
            </a>
          </div>

          <!-- <div class="col-6 col-lg-4" data-aos="fade-up" data-aos-delay="300">
            <a class="card shadow-1 hover-shadow-7" href="/dhanvantari" target="_blank">
              <img class="card-img-top" :src="medicalBricks1" alt="Demo" />
              <div class="card-body">
                <h6 class="mb-0">Medical Bricks</h6>
              </div>
            </a>
          </div> -->
        </div>
      </div>
    </section>
    <section class="section technology-section overflow-hidden bg-gray">
      <div class="container">
        <header class="section-header">
          <h2>Our Technology Stack</h2>
          <hr />
          <p class="lead">
            We use our experties, insights and experience in order to sync with your project
            requirements, keep scalability in mind and select the latest technology and trending
            tools to build your application.
          </p>
        </header>
        <div class="row justify-content-center">
          <div class="col-md-8">
            <ul class="nav nav-tabs justify-content-md-center" id="myTab" role="tablist">
              <li class="nav-item">
                <a class="nav-link active" data-toggle="tab" href="#backend" role="tab">
                  Backend
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#frontend" role="tab"> Frontend</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#mobile" role="tab"> Mobile </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#cloud" role="tab"> DevOps</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#tools" role="tab"> Tools</a>
              </li>
            </ul>

            <div class="tab-content" id="myTabContent">
              <div
                class="tab-pane fade show active"
                id="backend"
                role="tabpanel"
                aria-labelledby="backend-tab"
              >
                <div class="row justify-content-md-center">
                  <ul class="list-unstyled clearfix">
                    <li v-for="(item, index) in backendStack" :key="index">
                      <i
                        class="sprite"
                        :style="{
                          width: item.width,
                          'background-position': item.backGroundPosition,
                          height: item.height,
                        }"
                      ></i>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="frontend"
                role="tabpanel"
                aria-labelledby="profile-tab"
              >
                <div class="row justify-content-md-center">
                  <ul class="list-unstyled clearfix">
                    <li v-for="(item, index) in frontendStack" :key="index">
                      <i
                        class="sprite"
                        :style="{
                          width: item.width,
                          'background-position': item.backGroundPosition,
                          height: item.height,
                        }"
                      ></i>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="tab-pane fade" id="mobile" role="tabpanel" aria-labelledby="mobile-tab">
                <div class="row justify-content-md-center">
                  <ul class="list-unstyled clearfix">
                    <li v-for="(item, index) in mobileStack" :key="index">
                      <i
                        class="sprite"
                        :style="{
                          width: item.width,
                          'background-position': item.backGroundPosition,
                          height: item.height,
                        }"
                      ></i>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="tab-pane fade" id="cloud" role="tabpanel" aria-labelledby="cloud-tab">
                <div class="row justify-content-md-center">
                  <ul class="list-unstyled clearfix">
                    <li v-for="(item, index) in cloudStack" :key="index">
                      <i
                        class="sprite"
                        :style="{
                          width: item.width,
                          'background-position': item.backGroundPosition,
                          height: item.height,
                        }"
                      ></i>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="tab-pane fade" id="tools" role="tabpanel" aria-labelledby="tools-tab">
                <div class="row justify-content-md-center">
                  <ul class="list-unstyled clearfix">
                    <li v-for="(item, index) in toolStack" :key="index">
                      <i
                        class="tool-stack"
                        :style="{
                          width: item.width,
                          'background-position': item.backGroundPosition,
                          height: item.height,
                        }"
                      ></i>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import header from "../../components/Header.vue";
import aphale from "../../assets/img/preview/aphale.png";
import aphale1 from "../../assets/img/preview/aphale_1.jpg";
import aphale2 from "../../assets/img/preview/aphale_2.jpg";
import inventory from "../../assets/img/preview/inventory_home.jpg";
import medicalBricks from "../../assets/img/preview/medical_bricks.jpg";
import kabir from "../../assets/img/preview/kabir.jpg";
import kabir1 from "../../assets/img/preview/kabir_1.jpg";
import kabir2 from "../../assets/img/preview/kabir_2.jpg";
import piling from "../../assets/img/preview/piling.jpg";
import piling1 from "../../assets/img/preview/piling_1.jpg";
import piling2 from "../../assets/img/preview/piling_2.jpg";
import dhanvantari1 from "../../assets/img/preview/dhanvantari_1.png";
import dhanvantari2 from "../../assets/img/preview/dhanvantari_2.png";
import inventory1 from "../../assets/img/preview/inventory_1.jpg";
import medicalBricks1 from "../../assets/img/preview/medical_bricks_1.jpg";
import dhanvantari6 from "../../assets/img/preview/dhanvantari_6.png";
import amsaSprite from "../../assets/img/amsa-sprite.gif";
import noip from "../../assets/img/preview/noip.jpg";
import noip1 from "../../assets/img/preview/noip_1.jpg";
import rajput from "../../assets/img/preview/rajput_electricals.jpg";
import rajput2 from "../../assets/img/preview/rajput_electricals2.jpg";

export default {
  data: () => ({
    aphale,
    inventory,
    medicalBricks,
    kabir,
    piling,
    dhanvantari1,
    dhanvantari2,
    piling1,
    kabir1,
    aphale1,
    aphale2,
    kabir2,
    piling2,
    inventory1,
    medicalBricks1,
    dhanvantari6,
    noip,
    noip1,
    rajput,
    rajput2,
    cloudStack: [
      {
        label: "docker",
        width: "160px",
        backGroundPosition: "-8px -750px",
        height: "50px",
      },
      {
        label: "aws",
        width: "125px",
        backGroundPosition: "-4px -523px",
        height: "75px",
      },
      {
        label: "terraform",
        width: "100px",
        height: "100px",
        backGroundPosition: "-235px -405px",
      },
    ],
    toolStack: [
      {
        label: "github",
        width: "114px",
        backGroundPosition: "0px -813px",
        height: "50px",
      },
      {
        label: "slack",
        width: "110px",
        backGroundPosition: "0px -867px",
        height: "50px",
      },
      {
        label: "jira",
        width: "100px",
        backGroundPosition: "-114px -867px",
        height: "50px",
      },
      {
        label: "ngrok",
        width: "82px",
        backGroundPosition: "-268px -813px",
        height: "50px",
      },
      {
        label: "trello",
        width: "50px",
        backGroundPosition: "-74px -758px",
        height: "50px",
      },
      {
        label: "basecamp",
        width: "152px",
        backGroundPosition: "-116px -813px",
        height: "50px",
      },
      {
        label: "gitlab",
        width: "120px",
        backGroundPosition: "0 -701px",
        height: "50px",
      },
      {
        label: "postman",
        width: "54px",
        backGroundPosition: "-240px -758px",
        height: "50px",
      },
    ],
    mobileStack: [
      {
        label: "Android",
        width: "80px",
        backGroundPosition: "-136px -427px",
        height: "75px",
      },
      {
        label: "ios",
        width: "116px",
        backGroundPosition: "-20px -427px",
        height: "60px",
      },
      {
        label: "Flutter",
        width: "190px",
        backGroundPosition: "-10px -360px",
        height: "60px",
      },

      {
        label: "kotlin",
        width: "156px",
        backGroundPosition: "-4px -610px",
        height: "54px",
      },
      {
        label: "react native",
        width: "106px",
        height: "60px",
        backGroundPosition: "-65px -812px",
      },
    ],
    frontendStack: [
      {
        label: "html5",
        width: "225px",
        backGroundPosition: "-130px -528px",
        height: "80px",
      },
      {
        label: "angular",
        width: "175px",
        backGroundPosition: "0px -290px",
        height: "60px",
      },
      {
        label: "vue",
        width: "150px",
        backGroundPosition: "-190px -215px",
        height: "60px",
      },
      {
        label: "react",
        width: "75px",
        backGroundPosition: "-50px -668px",
        height: "70px",
      },
    ],
    backendStack: [
      {
        label: "php",
        width: "120px",
        height: "62px",
        backGroundPosition: "-220px -30px",
      },
      {
        label: "laravel",
        width: "175px",
        backGroundPosition: "7px -110px",
        height: "60px",
      },
      {
        label: "go",
        width: "200px",
        backGroundPosition: "-12px -18px",
        height: "80px",
      },
      {
        label: "python",
        width: "175px",
        height: "60px",
        backGroundPosition: "-168px -812px",
      },
      {
        label: "django",
        width: "130px",
        height: "62px",
        backGroundPosition: "-205px -680px",
      },
      {
        label: "node",
        width: "120px",
        height: "62px",
        backGroundPosition: "-220px -110px",
      },
    ],
  }),
  components: {
    "header-component": header,
  },
};
</script>
<style scoped>
.technology-section .sprite {
  background: url("../../assets/img/technology-sprite.gif") no-repeat center center;
  display: block;
}

.technology-section .tool-stack {
  background: url("../../assets/img/amsa-tools-sprite.webp") no-repeat center center;
  display: block;
  background-size: 355px 1000px;
}

.technology-section li {
  display: inline-block;
  margin: 0 10px;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #ef3d5b;
  font-weight: bold;
  background: transparent;
  border: none;
}
</style>
